import { Injectable } from '@angular/core';
import { ServiceCallUtilsService } from '../service-call-utils.service';
import { constants } from '../constants';

interface SaveAcceptPolicyObject{
  tradeMark: string
  acceptChannel: string
  documentType: string
  document: string
  phoneNumber: string
}
@Injectable({
  providedIn: 'root'
})
export class LoginService {

  /**
   * @author eciro
   * @description variable que guarda la ultima url a la que se ingreso desde el menú
   */
  private urlToRedirect: string = '';
  constructor(private serviceCallUtilsService: ServiceCallUtilsService) { }

  /**
   * Description: Método que llama el servicio web de validar código
   * Autor: Diego Diaz
   * @param documentId cédula del usuario
   * @return Mensaje de confirmación de la validación
   */
  validateUserMainInformation(documentId, idType) {
    return this.serviceCallUtilsService.callPostWebService(constants.ENDPOINT_LOGIN_VALIDATE_USER_INFORMATION, { "identificationType": idType, "identificationNumber": documentId });
  }

  /**
   * Description: Método que llama el servicio web de enviar código de validación
   * Autor: Diego Diaz
   * @param documentId cédula del usuario
   * @param addNumber numero adicional del usuario (opcional)
   * @param docType tipo documento
   * @return Mensaje de confirmación del envio del SMS
   */
  sendValidationCodeBySMS(documentId, addNumber, docType) {
    return this.serviceCallUtilsService.callPostWebService(constants.ENDPOINT_LOGIN_SEND_VALIDATION_CODE_SMS, { "documentId": documentId, "phone": addNumber, "documentType": docType,});
  }

  saveAcceptPolicy( saveAcceptPolicyObject:SaveAcceptPolicyObject ) {
    return this.serviceCallUtilsService.callPostWebService(constants.ENDPOINT_SAVE_ACCEPT_POLICY, saveAcceptPolicyObject);
  }
  /**
   * Description: Método que llama el servicio web de validar código
   * Autor: Diego Diaz
   * @param pin código de validación enviado por SMS previamente
   * @param documentId cédula del usuario
   * @param docType tipo cédula o pasaporte
   * @return Mensaje de confirmación de la validación del PIN
   */
  validateSMSCode(documentId, pin, docType) {
    return this.serviceCallUtilsService.callPostWebService(constants.ENDPOINT_LOGIN_VALIDATE_PIN_CODE, { "documentType": docType, "documentId": documentId, "pin": pin });
  }

  /**
   * Description: Método que llama el servicio web de actualizar información principal del usuario
   * Autor: Diego Diaz
   * @param accountId identificador del usuario
   * @param mainEmail email princpal
   * @return Mensaje de confirmación de la actualización
   */
  updateUserMainInfo(accountId, mainEmail) {
    return this.serviceCallUtilsService.callSecuredPostWebService(constants.ENDPOINT_LOGIN_UPDATE_USER_INFORMATION, { "billingAccountId": accountId, "email": mainEmail });
  }

   /**
   * Setter  de la variable urlToRedirect
   * @param url 
   */
  setUrlToRedirect(url:string){
    this.urlToRedirect = url;
  }

  /**
   * Getter  de la variable urlToRedirect
   * @param url 
   */
  getUrlToRedirect(){
    return this.urlToRedirect;
  }
}
